export const previousRoute = (pathname, numberOfPreviousRoute) => {
  return pathname
    .split('/')
    .slice(0, -1 * numberOfPreviousRoute)
    .join('/');
};
